import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { faVolumeUp } from "@fortawesome/free-solid-svg-icons/faVolumeUp";
import { faVolumeMute } from "@fortawesome/free-solid-svg-icons/faVolumeMute";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import { faInfo } from "@fortawesome/free-solid-svg-icons/faInfo";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons/faPlusCircle";
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash";
import { faPlay } from "@fortawesome/free-solid-svg-icons/faPlay";
import { faCommentSlash } from "@fortawesome/free-solid-svg-icons/faCommentSlash";
import { faComment } from "@fortawesome/free-solid-svg-icons/faComment";
import { faComments } from "@fortawesome/free-solid-svg-icons/faComments";
import { faBan } from "@fortawesome/free-solid-svg-icons/faBan";
import { faDoorOpen } from "@fortawesome/free-solid-svg-icons/faDoorOpen";
import { faCoins } from "@fortawesome/free-solid-svg-icons/faCoins";
import { faEdit } from "@fortawesome/free-solid-svg-icons/faEdit";
import { faBolt } from "@fortawesome/free-solid-svg-icons/faBolt";
import { faEye } from "@fortawesome/free-solid-svg-icons/faEye";
import { faExpand } from "@fortawesome/free-solid-svg-icons/faExpand";
import { faStar } from "@fortawesome/free-solid-svg-icons/faStar";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons/faPaperclip";
import { faUserShield } from "@fortawesome/free-solid-svg-icons/faUserShield";
import { faHeart } from "@fortawesome/free-solid-svg-icons/faHeart";
import { faExpandArrowsAlt } from "@fortawesome/free-solid-svg-icons/faExpandArrowsAlt";
import { faLock } from "@fortawesome/free-solid-svg-icons/faLock";
import { faLockOpen } from "@fortawesome/free-solid-svg-icons/faLockOpen";
import { faAt } from "@fortawesome/free-solid-svg-icons/faAt";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import { faFileImage } from "@fortawesome/free-solid-svg-icons/faFileImage";
import { faFileVideo } from "@fortawesome/free-solid-svg-icons/faFileVideo";
import { faHome } from "@fortawesome/free-solid-svg-icons/faHome";
import { faBullhorn } from "@fortawesome/free-solid-svg-icons/faBullhorn";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope";
import { faVideo } from "@fortawesome/free-solid-svg-icons/faVideo";
import { faBell } from "@fortawesome/free-solid-svg-icons/faBell";
import { faClock } from "@fortawesome/free-solid-svg-icons/faClock";
import { faCloudUpload } from "@fortawesome/free-solid-svg-icons/faCloudUpload";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons/faArrowUp";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons/faArrowDown";
import { faArrowUpFromBracket } from "@fortawesome/free-solid-svg-icons/faArrowUpFromBracket";
import { faMaximize } from "@fortawesome/free-solid-svg-icons/faMaximize";
import { faMinimize } from "@fortawesome/free-solid-svg-icons/faMinimize";
import { faCamera } from "@fortawesome/free-solid-svg-icons/faCamera";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons/faCircleExclamation";
import { faPeopleGroup } from "@fortawesome/free-solid-svg-icons/faPeopleGroup";
import { faKey } from "@fortawesome/free-solid-svg-icons/faKey";
import { faGem } from "@fortawesome/free-solid-svg-icons/faGem";



library.add(faVolumeUp);
library.add(faVolumeMute);
library.add(faCheck);
library.add(faTimes);
library.add(faInfoCircle);
library.add(faInfo);
library.add(faPlusCircle);
library.add(faTrash);
library.add(faPlay);
library.add(faCommentSlash);
library.add(faComment);
library.add(faComments);
library.add(faBan);
library.add(faDoorOpen);
library.add(faCoins);
library.add(faEdit);
library.add(faBolt);
library.add(faEye);
library.add(faExpand);
library.add(faStar);
library.add(faPaperclip);
library.add(faUserShield);
library.add(faHeart);
library.add(faExpandArrowsAlt);
library.add(faLock);
library.add(faLockOpen);
library.add(faAt);
library.add(faUser);
library.add(faFileImage);
library.add(faFileVideo);
library.add(faHome);
library.add(faBullhorn);
library.add(faEnvelope);
library.add(faVideo);
library.add(faBell);
library.add(faClock);
library.add(faCloudUpload);
library.add(faArrowUp);
library.add(faArrowDown);
library.add(faArrowUpFromBracket);
library.add(faMaximize);
library.add(faMinimize);
library.add(faCamera);
library.add(faCircleExclamation);
library.add(faPeopleGroup);
library.add(faKey);
library.add(faGem);


dom.watch();
